import { FacebookPixel } from '@/clients/shared-components/FacebookPixel';
import { GooglePixel } from '@/clients/shared-components/GooglePixel';
import { useBodyScroll } from '@/clients/shared-hooks/use-body-scroll';
import { SignedOut } from '@clerk/clerk-react';
import { Link } from 'react-router';
import { Outlet } from 'react-router-dom';
import { ProfAIAvatar } from '../components/ProfAIAvatar';
import styles from './login-styles.module.css';

export function LoginTemplate() {
  const { direction, amount } = useBodyScroll();
  const hideNavbar = direction === 'down' && amount > 10;
  const navbarClassName = `${styles.navbar} ltr:pr-6 rtl:pl-6 ${hideNavbar ? styles.hidden : ''}`;
  const headerClassName = amount < 10 ? '' : 'shadow';
  return (
    <div className={styles.screen}>
      <header className={headerClassName}>
        <SignedOut>
          <div className={navbarClassName}>
            <Link to="/" className="flex items-center px-4">
              <ProfAIAvatar size={40} />
            </Link>
          </div>
        </SignedOut>
      </header>
      <main>
        <Outlet />
      </main>
      <footer className="flex flex-col justify-end">
        <div className="pb-2">
          <div
            className={styles['mobile-footer-copyright']}
            style={{
              width: '96%',
              textAlign: 'left',
              margin: '0 2%',
              fontWeight: '200',
              fontSize: '14px',
            }}
          >
            &copy; 2025 ProfAI, All Rights Reserved
          </div>
        </div>
      </footer>
      <FacebookPixel authedUser={false} />
      <GooglePixel authedUser={false} />
    </div>
  );
}
